import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Popover, List, ListItem, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCategories } from '../../actions/categoryAction';

const MinCategory = () => {
    const dispatch = useDispatch();
    const { categories } = useSelector((state) => state.categories);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openId, setOpenId] = useState(null);

    useEffect(() => {
        dispatch(getCategories());
    }, [dispatch]);

    const handlePopoverOpen = (event, categoryId) => {
        setAnchorEl(event.currentTarget);
        setOpenId(categoryId);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
        setOpenId(null);
    };

    const getLink = (category) => {
        if (category.children && category.children.length > 0) {
            return `/categories/${category.name}`;
        }
        return `/search?category=${category.name}`;
    }

    return (
        <Box
            component="section"
            sx={{
                display: { xs: 'none', sm: 'block' },
                bgcolor: 'background.paper',
                width: '100%',
                px: { xs: 2, sm: 12 },
                overflow: 'visible',
                borderBottom: 1,
                borderColor: 'divider',
                position: 'sticky',
                top: { xs: 56, sm: 64 },
                zIndex: 1100,
            }}
        >
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 0.5,
            }}>
                {categories && categories.map((el, i) => (
                    <div key={i} onMouseEnter={(e) => handlePopoverOpen(e, el._id)} onMouseLeave={handlePopoverClose}>
                        <Link
                            to={getLink(el)}
                            style={{ textDecoration: 'none' }}
                        >
                            <Box
                                sx={{
                                    fontSize: '0.875rem',
                                    p: 1,
                                    color: 'text.primary',
                                    fontWeight: 500,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.125rem',
                                    '&:hover': {
                                        color: 'primary.main',
                                        '& span': {
                                            color: 'primary.main',
                                        },
                                    },
                                }}
                            >
                                {el.name}
                                {el.children && el.children.length > 0 && (
                                    <Box
                                        component="span"
                                        sx={{
                                            color: 'text.secondary',
                                        }}
                                    >
                                        <ExpandMoreIcon sx={{ fontSize: "16px" }} />
                                    </Box>
                                )}
                            </Box>
                        </Link>
                        {el.children && el.children.length > 0 && (
                            <Popover
                                id={`category-popover-${el._id}`}
                                open={openId === el._id}
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                                onClose={handlePopoverClose}
                                disableRestoreFocus
                                sx={{
                                    pointerEvents: 'none',
                                }}
                            >
                                <div
                                    onMouseEnter={(e) => handlePopoverOpen(e, el._id)}
                                    onMouseLeave={handlePopoverClose}
                                    style={{ pointerEvents: 'auto' }}
                                >
                                    <List>
                                        {el.children.map((child) => (
                                            <ListItem button key={child._id} component={Link} to={`/search?category=${child.name}`}>
                                                <ListItemText primary={child.name} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </div>
                            </Popover>
                        )}
                    </div>
                ))}
            </Box>
        </Box>
    );
};

export default MinCategory;
